<template>
  <v-row>
    <v-card max-width="100%" width="100%">
      <v-toolbar color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('stats.stock')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "area" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-col v-if="!load" cols="12" align="center" style="height: 400px">
          <v-progress-circular
          style="margin-top: 150px"
            :size="100"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
        <v-row wrap>
          <v-col :cols="colSize" v-for="n in $store.getters['game/assignableCompanies'].length" :key="n">
            <div :id="'chart' + (n - 1)"></div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-row>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "StockDelay",
  data() {
    return {
      type: "bar",
      charts: [],
      load: false
    };
  },
  mounted() {
    setTimeout(() => this.init(), 0)
  },
  beforeDestroy() {
    this.charts.forEach(chart => {
      if (chart) {
        chart.destroy()
        chart = null
      }
    });
  },
  methods: {
    init() {
      this.$store.getters["game/assignableCompanies"].forEach((company, index) => {
        this.render(company, index);
      })
    },
    render(company, index) {
      let categories = this.categories(company)
      let series = this.series(company)
      let stacked = this.type == 'bar' ? true : false
      if (this.charts[index]) {
        this.charts[index].updateOptions({
          series: series,
          xaxis: {
            categories: categories
          },
          chart: {
            type: this.type,
            stacked: stacked
          }
        }, true);
      } else {
        this.charts[index] = new ApexCharts(document.querySelector("#chart" + index), {
          colors:['#008ffb', '#E91E63'],
          series: series,
          xaxis: {
            categories: categories
          },
          yaxis: {
            min: Math.floor(this.min / 10) * 10,
            max: Math.ceil(this.max / 10) * 10
          },
          chart: {
            type: this.type,
            height: 260,
            stacked: stacked
          },
          title: {
            text: company.name,
            align:  'center'
          }
        });
        this.load = true
        this.charts[index].render();
      }
    },
    categories() {
      let categories = [];
      for (let index = 0; index < this.week; index++) {
        categories.push(this.$t("general.smallWeek") + (index + 1));
      }
      return categories;
    },
    series(company) {
      let series = [];
      series.push({
        name: company.name + ' (Stock)',
        data: company.data.value.stock
      });
      series.push({
        name: company.name + ' (Rupture)',
        data: company.data.value.remains.map((val) => -val)
      });
      return series;
    },
    async changeType () {
      for (let index = 0; index < this.charts.length; index++) {
        await this.charts[index].destroy()
        this.charts[index] = null
      }

      if (this.type == 'area') {
        this.type = 'bar'
      } else {
        this.type = 'area'
      }
      this.$store.getters["game/assignableCompanies"].forEach((company, index) => {
        this.render(company, index);
      })
    }
  },
  computed: {
    week() {
      let max = 0;
      this.$store.getters["game/assignableCompanies"].forEach(company => {
        if (company.data.value.remains.length > max) {
          max = company.data.value.remains.length;
        }
      });
      return max;
    },
    min() {
      let min = 0
      this.$store.getters["game/assignableCompanies"].forEach(company => {
        company.data.value.remains.forEach(remain => {
          if (remain > min) {
            min = remain
          }
        });
      });
      return -min
    },
    max() {
      let max = 0
      this.$store.getters["game/assignableCompanies"].forEach(company => {
        company.data.value.stock.forEach(stock => {
          if (stock > max) {
            max = stock
          }
        });
      });
      return max;
    },
    colSize() {
      return this.$store.getters["game/assignableCompanies"].length > 1 ? '6' : '12';
    }
  }
};
</script>
